import '@fontsource-variable/open-sans'

document.addEventListener('DOMContentLoaded', () => {
    // Project entry point.
})
